import React, { useState, useEffect } from "react";
import Headers from "../components/Headers";
import Footer from "../components/Footer";
import { Link, useNavigate } from "react-router-dom";
import FadeLoader from "react-spinners/FadeLoader";
import { useSelector, useDispatch } from "react-redux";
import { customer_login, messageClear } from "../store/reducers/authReducer";
import toast from "react-hot-toast";

const Login = () => {
  const { loader, successMessage, errorMessage, userInfo } = useSelector(
    (state) => state.auth
  );
  const dispatch = useDispatch();
  const [resetPopup, setResetPopup] = useState(false);
  const navigate = useNavigate();
  const [state, setState] = useState({
    email: "",
    password: "",
  });

  const inputHandle = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };
  const login = (e) => {
    e.preventDefault();
    dispatch(customer_login(state));
  };

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(messageClear());
    }
    if (errorMessage) {
      toast.error(errorMessage);
      dispatch(messageClear());
    }
    if (userInfo) {
      navigate("/");
    }
  }, [successMessage, errorMessage, dispatch]);

  const displayReset = () => {
    setResetPopup(!resetPopup);
  };

  return (
    <div>
      {loader && (
        <div className="w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-[#38303033] z-[999]">
          <FadeLoader />
        </div>
      )}

      <div
        className=" bg-cover bg-no-repeat relative bg-left"
        style={{
          backgroundImage: `url(${process.env.REACT_APP_CLIENT_URL}/images/rBg.jpg)`,
        }}
      >
        <Headers />
        <div className="w-full justify-center items-center py-10 mt-5">
          <div className="grid grid-cols-2 lg:block w-[60%] md:w-[95%] mx-auto bg-[#ffffffb8] rounded-md backdrop-blur-md border-t-4 border-mainColor">
            <div className="px-8 py-8">
              <h2
                className="text-2xl mb-2 text-center gradient-t0"
                style={{ textShadow: "-2px 2px 5px #00022e43" }}
              >
                مرحباً بكم في منصة طبيبي
              </h2>
              <p className="text-xs mb-3 text-center">
                Veuillez vous inscrire pour commencer ! <br />! الرجاء تسجيل
                الدخول للبدء
              </p>
              <div>
                <form onSubmit={login} className="text-slate-600">
                  <div className="flex flex-col gap-1 mb-2">
                    <div className="flex justify-between px-1">
                      <label htmlFor="email">Email</label>
                      <label htmlFor="email">بريد إلكتروني</label>
                    </div>
                    <input
                      onChange={inputHandle}
                      value={state.email}
                      type="email"
                      className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-indigo-500 rounded-md"
                      id="email"
                      name="email"
                      placeholder="email"
                    />
                  </div>
                  <div className="flex flex-col gap-1 mb-4">
                    <div className="flex justify-between px-1">
                      <label htmlFor="password">Mot de passe</label>
                      <label htmlFor="password"> كلمة المرور</label>
                    </div>
                    <input
                      onChange={inputHandle}
                      value={state.password}
                      type="password"
                      className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-indigo-500 rounded-md"
                      id="password"
                      name="password"
                      placeholder="password"
                    />
                  </div>
                  <div className="flex justify-end mb-4 px-2">
                    <Link
                      className="text-[#1f38b8] font-bold text-xs text-right "
                      to="/reset-password"
                    >
                      هل نسيت كلمة السر؟
                    </Link>
                  </div>
                  <button className="main-btn1 w-full">
                    Login - تسجيل الدخول
                  </button>
                </form>
                <div className="flex justify-center items-center py-2">
                  <div className="h-[1px] bg-slate-300 w-[95%]"></div>
                  <span className="px-3 text-slate-600">or</span>
                  <div className="h-[1px] bg-slate-300 w-[95%]"></div>
                </div>
              </div>
              <div className="text-center text-slate-900 pt-1">
                <p>
                  ليس لديك حساب حتى الآن؟{" "}
                  <Link className="text-[#1f38b8] font-bold" to="/register">
                    سجل هنا
                  </Link>
                </p>
              </div>
              <div className="text-center text-slate-900 pt-5">
                <p>
                  {" "}
                  <a
                    target="_black"
                    className="text-[#1fb8b0] font-bold underline"
                    href={`${process.env.REACT_APP_PARTNER_URL}/login`}
                  >
                    سجل معنا كطبيب او كمورد صحي
                  </a>{" "}
                </p>
              </div>
            </div>
            <div
              className="w-full lg:w-0 lg:hidden bg-cover bg-no-repeat bg-center rounded-r-md "
              style={{
                backgroundImage: `url(${process.env.REACT_APP_CLIENT_URL}/images/loginBg.jpg)`,
              }}
            ></div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Login;
